import { MetaData } from '@xing-com/crate-lebenslauf-components';
import { Frame } from '@xing-com/crate-lebenslauf-xinglets';
import type { Xinglet } from '@xing-com/crate-xinglet';

import { Templates } from './templates';

const title =
  'Lebenslauf Vorlagen und Muster für Deine Bewerbung | Lebenslauf.com';
const description =
  'Wähle eine unserer professionellen Lebenslauf Vorlagen aus. Ändere jederzeit die Farbe und Layout in unserem Online-Editor. Starte jetzt kostenlos ✓';

export default class TemplatesXinglet implements Xinglet {
  public getComponent() {
    return (): JSX.Element => (
      <Frame>
        <MetaData title={title} description={description} />
        <Templates />
      </Frame>
    );
  }
}
